<template>
  <div class="quick" id="quick">
    <!-- 卡权益搜索数量 -->
    <!-- <ul class="quick-wrap" v-if="count > 0 && cardInfos.length > 0">
      <li class="quick-item quick-tab quick-card" @click="onCardRouter()">
        <span class="quick-key">
          <span class="red-font">{{ keyword }}</span>
          <span>{{ TLang("可用福利卡抵扣的商品", "card") }}</span>
        </span>
        <span :class="['quick-num ', getDFLANG() ? 'quick-num-en' : '']">
          {{ ReplaceText("XXX", count, TLang("约个商品", "result")) }}
        </span>
      </li>
    </ul> -->
    <!-- 联想词 --> <!-- 频道内搜索 只展示搜索联想词 (超值馈项目) -->
    <ul
      class="quick-wrap"
      v-if="
        suggestWords && suggestWords.length && !getBFD() && !checkXcxChannel()
      "
    >
      <li
        class="quick-item quick-tab"
        v-for="(item, index) in suggestWords"
        :key="index + 'sxd'"
        @click="clickSuggest(item)"
      >
        <span class="quick-key">
          <i :style="{ fontStyle: 'normal' }" class="channelTags"> </i>
          <span v-if="item.highlight" v-html="item.highlight"></span>
          <span v-else>{{ item.name }}</span>
        </span>
      </li>
    </ul>
    <!-- 随心兑商家样式不一致 -->
    <ul
      class="quick-wrap"
      v-if="searches.length && (isUnion() ||  checkXcxChannel()||checkUnifyShop()) && !singleChannel"
    >
      <li
        :class="[
          {
            'quick-change': checkProductType(item),
            'quick-item': !checkProductType(item),
            'quick-link': !checkProductType(item),
            'quick-change-en': checkProductType(item) && getDFLANG(),
          },
        ]"
        v-for="(item, index) in searches"
        :key="index + 'sxd'"
        @click="onClick(item)"
      >
        <span class="quick-line" v-if="checkProductType(item)">
          <span>
            <span
              class="quick-merchant"
              :class="{ support: !!item.supportedMold }"
            >
              <span class="quick-key" v-if="item.highlight">
                <i :style="{ fontStyle: 'normal' }" class="channelTags">
                  <SingleTag
                    v-if="item.skuTag && item.skuTag.mktFrontType === 9005"
                    :datas="item.skuTag"
                  /> </i
                ><span
                  :style="{ marginLeft: item.skuTag && '0' }"
                  v-html="item.highlight"
                ></span>
              </span>
              <span v-else>
                <i :style="{ fontStyle: 'normal' }" class="channelTags">
                  <SingleTag
                    v-if="item.skuTag && item.skuTag.mktFrontType === 9005"
                    :datas="item.skuTag"
                  /> </i
                >{{ item.name }}
              </span>
              <span
                :class="[
                  'quick-tip',
                  'suixindui',
                  {
                    enSXD: getDFLANG(),
                  },
                ]"
                v-if="item.productType == '随心兑'"
              >
                {{ TLang('随心兑', "sxChange") }}
              </span>
              <span class="quick-tip canbu" v-if="!!item.supportedMold">
                支持使用餐补
              </span>
              <span
                class="quick-tip merchant"
                :class="[
                  'quick-tip',
                  'merchant',
                  {
                    enXXSH: getDFLANG(),
                  },
                ]"
                v-if="item.productType == '线下商户' || item.productType == '超市便利'"
              >
                <!-- {{ TLang("美食汇", "sxChange") }} -->
                <!-- 2023.08.21 定制tab项目，角标统一改为随心兑 -->
                {{ TLang('随心兑', "sxChange") }}
              </span>
            </span>
            <!-- <span class="quick-tip">随心兑</span> -->
            <span class="quick-address">{{ item.storeAddress }}</span>
          </span>
          <span class="quick-distance" v-if="item.distance">
            {{ item.distance }}
          </span>
        </span>
        <span
          class="quick-key"
          v-if="item.highlight && !checkProductType(item)"
        >
          <i :style="{ fontStyle: 'normal' }" class="channelTags">
            <SingleTag
              v-if="item.skuTag && item.skuTag.mktFrontType === 9005"
              :datas="item.skuTag"
            /> </i
          ><span
            :style="{ marginLeft: item.skuTag && '0' }"
            v-html="item.highlight"
          ></span>
        </span>
        <span v-else-if="!checkProductType(item)">
          <i :style="{ fontStyle: 'normal' }" class="channelTags">
            <SingleTag
              v-if="item.skuTag && item.skuTag.mktFrontType === 9005"
              :datas="item.skuTag"
            /> </i
          >{{ item.name }}
        </span>
        <span
          class="quick-num"
          v-if="
            item.sellingPrice &&
            parseFloat(item.sellingPrice) == item.sellingPrice &&
            !checkProductType(item) &&
            item.isShowPrice == 1
          "
        >
          {{ `${parseFloat(item.sellingPrice) == 0 && item.productType == '一企学' ? TLang('免费', 'quick') : parseFloat((item.sellingPrice * unionScale).toFixed(2)) + TLang(unionName, 'card')}` }}
        </span>
        <span
          class="quick-num"
          v-else-if="item.productType == '一企学'"
        >
          {{ TLang('免费', 'quick') }}
        </span>
      </li>
    </ul>

    <!-- 频道搜索结果 -->
    <ul class="quick-wrap" v-if="products.length && !singleChannel">
      <li
        class="quick-item quick-tab"
        v-for="(item, index) in products"
        :key="index"
        @click="onRouter(item)"
      >
        <span class="quick-key">
          <span class="red-font">{{ item.key }}</span>
          <span>{{ item.productTypeText }}</span>
        </span>
        <span :class="['quick-num ', getDFLANG() ? 'quick-num-en' : '']">{{
          checkProductType(item)
            ? ReplaceText("XXX", item.qty, TLang("约个门店", "result"))
            : ReplaceText("XXX", item.qty, TLang("约个商品", "result"))
        }}</span>
      </li>
    </ul>
    <Nothing v-if="isEmpty" :isFast="true"></Nothing>
  </div>
</template>

<script>
import Nothing from "./Nothing";
import SingleTag from "./SingleTag";
import {
  getQueryString,
  gioClickHandle,
  unionFlag,
  checkFromChannel,
  getCookieAddressInfo,
} from "../utils";
import { checkUnifyShop } from "@/utils";
import { checkXcx, checkLeFuXcx } from "../utils/checkXcx";
import { publicFunc } from "../utils/func";
import { mapState } from "vuex";
export default {
  name: "fastMatch",
  data() {
    return {
      city: getCookieAddressInfo('cityId') || getQueryString("city") || 145,
      key: this.keyword,
      isEmpty: false,
      unionName: window.union_name || this.TLang("福豆", "card"),
      unionScale: window.union_scale || 1,
    };
  },
  computed: {
    ...mapState({
      products: (state) => state.quick.products,
      searches: (state) => state.quick.searches,
      suggestWords: (state) => state.quick.suggestWords,
      count: (state) => state.quick.count,
      keyword: (state) => state.quick.keyword,
      cardInfos: (state) => state.quick.cardInfos,
      singleChannel: state => state.singleChannel, // 频道内搜索 只展示搜索联想词 (超值馈项目)
    }),
  },
  components: {
    Nothing,
    SingleTag,
  },
  methods: {
    checkUnifyShop:checkUnifyShop,
    getBFD() {
      // 判断是否是甄选
      const origin = window.location.origin
      if (origin.indexOf('m-zx') > -1) {
        return false
      }
      const union = unionFlag() || sessionStorage.getItem('dffl_union');
      return union && !checkUnifyShop();
    },
    getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      return publicFunc.getCookie("df_lang") == "en-US" && (union || checkUnifyShop());
    },
    checkXcxChannel() {
      let flag = false;
      // if(checkFromChannel() && checkXcx() && !checkLeFuXcx()) {
      // 小程序内嵌的频道是固定的，所以可以只判断小程序环境
      if (checkXcx() && !checkLeFuXcx()) {
        flag = true;
      }
      return flag;
    },
    isUnion() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      console.log("union", !!union);
      return !!union;
    },
    onClick(obj) {
      //  1.投放  2.坑位
      if (obj && obj.bizType && obj.bizType === 2) {
        // 触发埋点
        gioClickHandle("DF_elementClick", {
          df_channle: "",
          df_pagename: "搜索页",
          df_modulename: "快速搜索",
          df_elementname: "点击商品",
          df_pageType: "坑位商品",
          df_clickvalue: obj.position,
          df_searchKeyword: this.keyword,
          df_goodsname: obj.name,
          df_sku_code: obj.skuCode,
          df_goodsChannel: obj.gioChannel,
          df_goodsChannelId: obj.gioChannelName,
        });
      }
      window.df_sdk_common.location.href = obj.h5SkipUrl;
    },

    clickSuggest(obj) {
      // 触发埋点
      gioClickHandle("DF_elementClick", {
        df_channle: "",
        df_pagename: "搜索页",
        df_modulename: "快速搜索",
        df_elementname: "搜索联想词",
        df_searchKeyword: this.keyword,
        df_content: obj.word,
      });
      this.$emit("handlerSearch", { key: obj.word }, false);
    },
    onRouter(obj) {
      gioClickHandle("DF_elementClick", {
        df_channle: "",
        df_pagename: "搜索页",
        df_modulename: "快速搜索",
        df_elementname: "产品类型",
        df_searchKeyword: obj.key,
        df_pageType: obj.productType,
      });
      const data = {
        key: obj.key,
        city: this.city,
        productTypes: obj.productType,
      };
      this.$emit("handlerSearch", data, false, obj.index, obj);
    },
    checkProductType(item) {
      let showMerchant = false;
      const isShow = item.productType == "超市便利" && item.type != 1; // 非超市便利的电子券
      if (item.productType == "随心兑" || item.productType == "线下商户" || isShow) {
        showMerchant = true;
      }
      return showMerchant;
    },
    onCardRouter() {
      const data = {
        key: this.keyword,
        city: this.city,
        productTypes: null,
        cardChoose: 1,
      };

      gioClickHandle("DF_elementClick", {
        df_searchKeyword: this.keyword || "未输入关键词",
        df_modulename: "快速搜索",
        df_elementname: "权益",
        df_pagename: "搜索页",
      });

      this.$emit("handlerSearch", data, false, 0);
    },
  },
  watch: {
    products(val) {
      this.isEmpty = val.length ? false : true;
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.quick {
  position: absolute;
  top: 44px * @375;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2004;
  box-sizing: border-box;
  background-color: #fff;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  &-wrap {
    padding-left: 10px;
    padding-right: 10px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid #ededed;
    .quick-item:last-child {
      &:after {
        transform: scale(0);
      }
    }
  }
  &-item {
    position: relative;
    display: flex;
    font-size: 12px;
    line-height: 35px;
    > span:first-child {
      flex: 1;
      .ellipsis();
    }
    &:after {
      .setBottomLine(#ededed);
    }
  }
  &-change {
    position: relative;
    font-size: 12px;
    padding-left: 23px;
    background: url(../assets/imgs/icon_merchant.png) left center no-repeat;
    background-size: 12.8px auto;
    &:after {
      content: none;
    }
    .quick-line {
      display: flex;
      align-content: space-between;
      width: 100%;
      border-bottom: 1px solid #e5e5e5;
      > span:first-child {
        width: 187px;
      }
      padding: 10px 0;
      .quick-merchant {
        color: #333;
        font-size: 12.8px;
        // width: 187px;
        position: relative;
        display: inline-block;
        width: auto;
        max-width: 100%;
        > span:first-child {
          // display: block;
          // width: 100%;
          display: inline-block;
          width: auto;
          max-width: 100%;
          height: 18px;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .quick-num {
        line-height: 32.5px;
      }
    }
    .quick-tip {
      position: absolute;
      // right: 55px;
      // top: 12px;
      right: -36px;
      top: 3px;
      width: 32.5px;
      height: 12.8px;
      line-height: 12.8px;
      text-align: center;
      color: #3FA6FF;
      background: #e7f1ff;
      border-radius: 4px;
      font-size: 10.24px;
    }
    .suixindui {
      // width: 46px;
      // right: -50.5px;
      background-color: rgba(250, 140, 22, 0.2);
      color: #fa8c16;
      border-radius: 2px;
    }
    .canbu {
      width: 66px;
      // right: -50.5px;
      background-color: rgba(250, 140, 22, 0.2);
      color: #fa8c16;
      right: -120px;
      border-radius: 2px;
    }
    .enSXD {
      min-width: 32.5px;
      width: auto;
      right: -95px * @375;
      padding: 0 2px * @375;
    }
    .merchant {
      width: 46px;
      right: -50.5px;
      // background-color: rgba(250, 140, 22, .2);
      // color: #FA8C16;
      border-radius: 2px;
    }
    .enXXSH {
      min-width: 46px;
      width: auto;
    }
    .quick-address {
      display: block;
      height: 14.5px;
      width: 187px;
      color: #999;
      font-size: 10.24px;
      line-height: 14.5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:last-child {
      .quick-line {
        border-bottom: none;
      }
    }
  }
  &-change-en {
    .quick-line {
      > span:first-child {
        max-width: 146px;
      }
    }
  }
  &-link {
    padding-left: 23px;
    background: url(../assets/imgs/icon_goods.png) left center no-repeat;
    background-size: 12.8px auto;
  }
  &-tab {
    padding-left: 23px;
    background: url(../assets/imgs/icon_search.png) left center no-repeat;
    background-size: 12.8px auto;
  }
  &-card {
    padding-left: 23px;
    background: url(../assets/imgs/icon_card.png) left center no-repeat;
    background-size: 12.8px auto;
  }
  &-key {
    flex: 1;
    color: #333;
    .ellipsis();
    > span {
      color: #999;
      // margin-left: 6px;
    }
  }
  &-num {
    color: #999;
    width: 100px;
    text-align: right;
  }
  &-num-en {
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-distance {
    position: absolute;
    line-height: 53px;
    top: 0;
    right: 0;
    font-size: 12.8px;
    font-weight: 400;
    color: #999;
  }
  .nothing {
    margin-top: 30px;
  }
  .support {
    max-width: 160px !important;
  }

  .red-font {
    color: red;
    margin-right: 5px;
  }
}
</style>
